import React, { useEffect, useState } from "react";

import LangSwitcher from "components/design_system/LangSwitcher";
import AccorLoader from "components/elements/AccorLoader";
import WebcamAi, { IFacingModeType, Point } from "components/WebcamAi";
import { Item } from "types/Item";
// import Typography, { ITypo, ITypoColor } from "components/design_system/Typography";
// import I18nStore from "stores/I18nStore";

import classes from "./classes.module.scss";
// import PointDisplayer from "components/materials/PointDisplayer";
import ItemDrawerStore from "stores/ItemDrawerStore";

export type DetectedObject = Point & {
	item: Item;
	showHand?: boolean;
};

export default React.memo(function Scan() {
	const [facingMode] = React.useState<IFacingModeType>("environment");

	const [, setPoints] = useState<Point[]>([]);
	const [progress, setProgress] = useState<number>(100);
	const [isReady, setIsReady] = useState<boolean>(false);
	//const [distanceThreshold, setDistanceThreshold] = useState<number>(50); // Default threshold 50%

	const [pauseDetection, setPauseDetection] = useState<boolean>(false);

	const onDetect = React.useCallback((points: Point[]) => setPoints(points), []);

	// const handleThresholdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	// 	setDistanceThreshold(parseInt(e.target.value, 10));
	// };

	useEffect(() => ItemDrawerStore.instance.onDrawerOpenChange(setPauseDetection), []);

	return (
		<div className={classes["root"]}>
			<WebcamAi key="WebcamAi" facingMode={facingMode} onDetect={onDetect} setProgress={setProgress} isPaused={pauseDetection} onReady={setIsReady} />
			{/* <PointDisplayer points={points} /> */}

			<div className={classes["lang_switcher"]}>
				<LangSwitcher />
			</div>

			{/* <div className={classes["threshold-slider-container"]}>
				<Typography typo={ITypo.TEXT_SM_MEDIUM} color={ITypoColor.WHITE} className={classes["threshold-label"]}>
					{I18nStore.getInstance().translate("pages.scan.detection_sensitivity") || "Detection Sensitivity"}: {distanceThreshold}%
				</Typography>
				<input type="range" min="1" max="100" value={distanceThreshold} onChange={handleThresholdChange} className={classes["threshold-slider"]} />
			</div> */}

			{!isReady && (
				<div className={classes["loader"]}>
					<AccorLoader progress={progress} />
				</div>
			)}
		</div>
	);
});
